import { useQuery } from "@tanstack/react-query";
import { QueryKeysEnum } from "../types/QueryKeysEnum";
import { getAccountsList } from "../generated-api/account";
import { useAccountClient } from "./useAccountClient";

export const useAccountList = (
  throwOnError?: boolean | ((error: Error) => boolean),
) => {
  const client = useAccountClient();

  const response = useQuery({
    queryKey: [QueryKeysEnum.AccountList],
    queryFn: async () => {
      const { data } = await getAccountsList({
        client,
        throwOnError: true,
      });

      return data;
    },
    throwOnError,
  });

  return response;
};
